import { atom } from 'jotai';

export const selectedInsightsPatientInfoAtom = atom<
  | {
      name: string;
      estimatedVisitId: number | undefined;
      apptDate: Date;
      patientId: number;
    }
  | undefined
>(undefined);
